import { AppDispatch } from "@config/store";
import { appSelect, resetDateRange, setDateRange } from "@entities/app";
import PresetDatePicker from "@pages/dashboard/components/preset/PresetDatePicker";
import { Plag0, Plag1, Plag3, Plag5 } from "@pages/dashboard/plugins";
import * as S from "@pages/dashboard/style.styled";
import { API_DATE_FORMAT, DISPLAY_DATE_FORMAT } from "@utils/const";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const DashboardPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { from, to } = useSelector(appSelect).dateRange;
  const dispatch = useDispatch<AppDispatch>();

  const onDateChange: RangePickerProps["onChange"] = (date, dateStrings) => {
    if (!dateStrings[0] && !dateStrings[1] && !date) {
      dispatch(resetDateRange());
      return;
    }

    dispatch(
      setDateRange({
        from: dayjs(dateStrings[0], DISPLAY_DATE_FORMAT).format(
          API_DATE_FORMAT
        ),
        to: dayjs(dateStrings[1], DISPLAY_DATE_FORMAT).format(API_DATE_FORMAT),
      })
    );
  };

  return (
    <S.Wrapper>
      <S.Header>
        <S.WrapCalendar>
          <PresetDatePicker
            activePreset={activeIndex}
            setActivePreset={setActiveIndex}
            onRangeChange={(range) => {
              dispatch(
                setDateRange({
                  from: range[0].format(API_DATE_FORMAT),
                  to: range[1].format(API_DATE_FORMAT),
                })
              );
            }}
          />
          <S.StyledRangePicker
            value={[dayjs(from, API_DATE_FORMAT), dayjs(to, API_DATE_FORMAT)]}
            format={DISPLAY_DATE_FORMAT}
            onChange={onDateChange}
          />
        </S.WrapCalendar>
      </S.Header>
      <S.Container>
        <S.WidgetWrap width="66%">
          <S.Widget>
            <Plag0 />
          </S.Widget>
        </S.WidgetWrap>
        <S.WidgetWrap width="33%">
          <S.Widget>
            <Plag1 />
          </S.Widget>
        </S.WidgetWrap>
        <S.WidgetWrap width="33%">
          <S.Widget>
            <Plag5 />
          </S.Widget>
        </S.WidgetWrap>
        <S.WidgetWrap width="66%">
          <S.Widget>
            <Plag3 />
          </S.Widget>
        </S.WidgetWrap>
      </S.Container>
    </S.Wrapper>
  );
};

export default DashboardPage;
